<template>
  <main>
    <div class="add-note">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.addNote") }}</h3>
            </template>
            <template v-slot:right-element>
              <router-link :to="{name: 'ListNotes'}" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </router-link>
            </template>
          </TopTemplate>
        </div>
      </div>
      <div v-if="is_created" class="alert alert-success" role="alert">
        {{ $t("notes.addNote") }} voir
        <router-link
          class="success_msg"
          :to="{
            name: 'DetailnoteSubject',
            params: {classid: this.selectclass, courseid: this.selectCourse, coursePeriode: this.selectPeriode},
          }"
          >details
        </router-link>
      </div>
      <div v-if="is_createdDraft" class="alert alert-success" role="alert">
        {{ $t("notes.draftNote") }}
        <router-link
          class="success_msg"
          :to="{
            name: 'DetailnoteSubject',
            params: {classid: this.selectclass, courseid: this.selectCourse, coursePeriode: this.selectPeriode},
          }"
          >detail
        </router-link>
      </div>

      <div v-if="isSelected" class="row container-select container-filter">
        <div class="col-sm-8">
          <h3 class="title-filter">
            <span>{{ $t("notes.criteres") }}</span> {{ filterSelections }}
            <span>({{ note.students.length }} {{ eleve }})</span>
          </h3>
        </div>
        <div v-if="add" class="col-sm-4">
          <div class="reset_student reset_note" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
      </div>
      <div v-if="!isSelected" class="row container-select container-filter content-crit">
        <h3 class="title-filter">{{ $t("notes.criteres") }}</h3>
        <span class="title-filter-sub">{{ $t("notes.sub-criere") }}</span>
        <div class="supparation"></div>

        <div class="col-sm-3 col-12 select-wrapper">
          <v-select
            v-if="!isSelected"
            v-model="note.classe_id"
            :options="classes"
            :class="{'is-invalid': v$.note.classe_id.$error && isError}"
            :searchable="false"
            label="name"
            class="form-control"
            placeholder="Classe"
            @update:modelValue="selectedClass($event)"
            :reduce="(option) => option.id"
          >
            <template #no-options="{search, searching, loading}">
              {{ $t("info.noResult") }}
            </template>
          </v-select>
        </div>
        <div class="col-sm-3 col-12 select-wrapper">
          <v-select
            v-if="!isSelected"
            v-model="note.period_id"
            :options="periods"
            :searchable="false"
            label="period"
            class="form-control"
            @update:modelValue="handlePeriod($event)"
            :disabled="disabledPeriod"
            :class="{'is-invalid': v$.note.period_id.$error && isError}"
            :reduce="(option) => option.id"
            placeholder="Période"
          >
            <template #no-options="{search, searching, loading}">
              {{ $t("info.noResult") }}
            </template>
          </v-select>
        </div>
        <div v-if="displayCategory" class="col-sm-3 col-12 select-wrapper">
          <v-select
            v-if="!isSelected"
            v-model="note.category_id"
            :options="categories"
            :class="{'is-invalid': v$.note.category_id.$error && isError}"
            :reduce="(option) => option.id"
            @update:modelValue="handleCategory"
            :searchable="false"
            label="name_fr"
            class="form-control"
            :disabled="disabledCategory"
            :placeholder="$t('common.category')"
          >
            <template #no-options="{search, searching, loading}">
              {{ $t("info.noResult") }}
            </template>
          </v-select>
        </div>
        <div class="col-sm-3 col-12 select-wrapper">
          <v-select
            v-if="!isSelected"
            v-model="note.course_id"
            :options="courses"
            :searchable="false"
            label="name"
            class="form-control"
            :disabled="disabledMatiere"
            :class="{'is-invalid': v$.note.course_id.$error && isError}"
            :reduce="(option) => option.id"
            placeholder="Matière"
          >
            <template #no-options="{search, searching, loading}">
              {{ $t("info.noResult") }}
            </template>
          </v-select>
        </div>
        <div class="col-sm-3 col-12 select-wrapper" :class="{'mt-2': displayCategory}">
          <v-select
            v-if="!isSelected"
            v-model="note.exam_id"
            :options="exam_type"
            :searchable="false"
            label="name"
            class="form-control"
            :disabled="disabledExam"
            :class="{'is-invalid': v$.note.exam_id.$error && isError}"
            :reduce="(option) => option.code"
            :placeholder="examType"
          >
            <template #no-options="{search, searching, loading}">
              {{ $t("info.noResult") }}
            </template>
          </v-select>
        </div>

        <div class="col-sm-12 col-12 select-wrapper">
          <a @click="valideCriter()" class="btn btn-primary button btn-confirm-filter"> Appliquer mes critères </a>
        </div>
      </div>

      <div v-if="isSelected" class="empty-message">
        <div class="col-md-12">
          <div v-if="!loading && note.students.length == 0" class="card mt-4">
            <div class="col-12 empty-result text-center pt-3">
              <p>{{ $t("common.emptysearshNote") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && note.students.length > 0 && isSelected">
        <div class="table message-list custom-table">
          <div class="content-note">
            <div class="row container-select container-filter container-note">
              <div class="col-sm-4">
                <h3 class="title-filter title-tab-note">
                  <span>{{ $t("notes.titlenote") }}</span>
                </h3>
              </div>
              <div v-if="isSelected && note.students.length > 0" class="col-sm-8 buttons">
                <div class="button-right d-flex justify-content-end btn-action-note">
                  <button type="submit" class="btn btn-outline-primary button btn-cancel" @click.prevent="cancelBtn()" :disabled="isSubmitted">{{ $t("common.annuler") }}</button
                  >&nbsp;&nbsp;
                  <button v-if="!published" type="submit" class="btn button btn-primary" @click="onSubmit(0)" :disabled="isSubmitted">{{ $t("common.sauvgarder") }}</button
                  >&nbsp;&nbsp;
                  <button type="submit" class="btn button btn-primary" @click="onSubmit(1)" :disabled="isSubmitted">
                    <span>{{ nameBtn }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table__note table">
                  <table>
                    <thead>
                      <tr>
                        <th class="col-md-4">Nom & prénom ({{ note.students.length }} Elèves)</th>
                        <th class="col-md-2">Absent</th>
                        <th class="col-md-2 text-center">Notes</th>
                        <th class="col-md-4">Remarque</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(student, index) in note.students" :key="index">
                        <td class="col-md-4 name-std">{{ student.first_name }} {{ student.last_name }}</td>
                        <td class="col-md-2">
                          <label class="container-checkbox">
                            <input :disabled="isSubmitted" v-model="student.absent" @change="changeNote(index)" type="checkbox" />

                            <span class="checkmark" />
                          </label>
                        </td>

                        <td class="col-md-2 text-center">
                          <div v-if="student.mark == -1 || student.absent">
                            <input type="text" readonly class="form-control note-input" />
                          </div>
                          <div v-else>
                            <input
                              :disabled="isSubmitted"
                              :class="{'is-invalid': v$.note.students.$each.$response.$data[index].mark.$error}"
                              v-model="student.mark"
                              class="form-control note-input testtest"
                              type="text"
                            />
                          </div>
                          <span v-if="v$.note.students.$each.$response.$data[index].mark.$error" class="invalid-feedback">{{ $t("validation.numericNote") }}</span>
                        </td>
                        <td class="col-md-4 text-center cment-inp">
                          <input
                            :disabled="(isSubmitted || student.absent) && !student.remark"
                            v-model="student.remark"
                            placeholder="Ajouter votre remarque"
                            type="text"
                            class="form-control"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isSelected && note.students.length > 0" class="col-12 buttons btn-action btn-action-note">
        <div class="button-right d-flex justify-content-end mb-4">
          <button type="submit" class="btn btn-outline-primary button btn-cancel" @click.prevent="cancelBtn()" :disabled="isSubmitted">{{ $t("common.annuler") }}</button
          >&nbsp;&nbsp;
          <button v-if="!published" type="submit" class="btn button btn-primary" @click="onSubmit(0)" :disabled="isSubmitted">{{ $t("common.sauvgarder") }}</button>&nbsp;&nbsp;
          <button type="submit" class="btn button btn-primary" @click="onSubmit(1)" :disabled="isSubmitted">
            <span>{{ nameBtn }}</span>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import NoteService from "../../services/note.service";
import useValidate from "@vuelidate/core";
import {required, helpers, requiredIf, numeric, between, numericMony} from "@vuelidate/validators";

export default {
  components: {
    TopTemplate,
    "v-select": vSelect,
  },
  data() {
    return {
      isErrorNote: false,
      is_created: false,
      is_createdDraft: false,
      add: true,
      loading: true,
      published: false,
      v$: useValidate(),
      isSelected: false,
      isDraft: null,
      isNotDraft: null,
      typeDevoire: "DEVOIR CONTRÔLE",
      isSubmitted: false,
      isError: false,
      classNameSelcted: null,
      periodNameSelcted: null,
      periodsSelcted: null,
      courseSelcted: null,
      classes: [],
      periods: [],
      exam_type: [],
      subjects: [{id: 1, name: "Arabe"}],
      tasks: [{id: 1, name: "Devoir de controle 1"}],
      courses: [],
      student: {
        mark: null,
      },
      selectclass: null,
      selectCourse: null,
      selectPeriode: null,
      note: {
        course_id: null,
        classe_id: null,
        period_id: null,
        subject_id: null,
        task_id: null,
        status: null,
        exam_type: null,
        exam_id: null,
        periodsSelcted: null,
        courseSelcted: null,
        exam_type_id: null,
        students: [],
        category_id: null,
      },
      categories: [],
      displayCategory: false,
      categorySelected: null,
      taskSelcted: null,
    };
  },
  validations() {
    return {
      note: {
        classe_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        period_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        course_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        exam_id: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        students: {
          $each: helpers.forEach({
            mark: {
              between: between(-1, 20),
              requiredIf: requiredIf((value, vm) => {
                return !vm.absent && !this.isDraft;
              }),
            },
          }),
        },
        category_id: {
          requiredIf: requiredIf((value, vm) => {
            return this.displayCategory;
          }),
        },
      },
    };
  },
  created() {
    this.classId = this.$route.params.id;
  },
  computed: {
    nameBtn() {
      return this.add ? this.$t("common.publier") : this.$t("common.modifier_note");
    },
    eleve() {
      return this.note.students.length > 1 ? "Elèves" : "Elève";
    },
    disabledPeriod() {
      return this.note.classe_id == null;
    },
    disabledCategory() {
      return this.note.period_id == null;
    },
    disabledMatiere() {
      return this.displayCategory ? this.note.category_id == null : this.note.period_id == null;
    },
    disabledExam() {
      return this.note.course_id == null;
    },
    filterSelections() {
      return this.classNameSelcted ? `${this.classNameSelcted} - ${this.periodsSelcted} ${this.categorySelected} - ${this.courseSelcted} - ${this.taskSelcted}` : "";
    },
    examType() {
      const schoolCategory = JSON.parse(localStorage.getItem("school_category"));
      return schoolCategory ? this.$t("common.type") : this.$t("barFiltre.examTypeText");
    },
  },
  mounted() {
    this.note.classe_id = this.$route.params.classid;
    this.note.course_id = this.$route.params.courseid;
    this.note.period_id = this.$route.params.periodid;
    this.note.exam_id = this.$route.params.examtypeid;
    if (this.note.classe_id && this.note.course_id && this.note.period_id && this.note.exam_id) {
      this.isSelected = true;
      this.add = false;
      this.ListStudentNotes();
    } else {
      this.add = true;
      this.ListNotesFilter();
    }
  },

  methods: {
    cancelBtn() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmCancel"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.resetFilter();
          }
        });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    changeNote(index) {
      this.note.students[index].mark = null;
    },
    resetFilter() {
      this.isSubmitted = false;
      this.isSelected = false;
      this.is_created = false;
      this.is_createdDraft = false;
      this.selectclass = this.note.classe_id;
      this.selectCourse = this.note.course_id;
      this.note = {
        classe_id: null,
        period_id: null,
        course_id: null,
        subject_id: null,
        task_id: null,
        exam_id: null,
        status: null,
        students: [],
      };
      this.classNameSelcted = null;
      this.periodNameSelcted = null;
      this.periodsSelcted = null;
      this.courseSelcted = null;
      this.taskSelcted = null;
      this.isError = false;
    },
    async selectedClass(event) {
      this.note.period_id = null;
      this.note.category_id = null;
      this.note.course_id = null;
      this.note.exam_id = null;
      const class_type_id = this.classes.find((x) => x.id === event)?.class_type_id || {};
      await this.ListNotesFilter(class_type_id);
      const selectedClass = this.classes.find((x) => x.id === event) || {};
      const {class_type_category, periods, exam_type, courses, field} = selectedClass;

      this.periods = periods;
      this.exam_type = exam_type;
      this.courses = courses;
      this.displayCategory = class_type_category === 1 || class_type_category === 4;

      if (this.displayCategory) {
        this.categories = field;
      }
    },
    handlePeriod() {
      this.note.category_id = null;
      this.note.course_id = null;
      this.note.exam_id = null;
    },

    handleCategory(event) {
      const selectedCategory = this.categories.find((x) => x.id === event) || {};
      this.note.course_id = null;
      this.note.exam_id = null;
      this.courses = selectedCategory.course || [];
    },
    async valideCriter() {
      try {
        this.isDraft = true;
        await this.v$.$validate();
        this.isError = true;
        if (!this.v$.$error) {
          const selectedClass = this.classes.find((item) => item.id === this.note.classe_id);
          this.classNameSelcted = selectedClass.name;
          this.periodNameSelcted = selectedClass.periods;

          const selectedPeriod = selectedClass.periods.find((item) => item.id === this.note.period_id);
          this.periodsSelcted = selectedPeriod.period;

          const selectedCategory = this.displayCategory ? selectedClass.field.find((item) => item.id == this.note.category_id) : {};
          this.categorySelected = this.displayCategory ? ` - ${selectedCategory.name_fr}` : "";
          const selectedCourse = this.displayCategory
            ? selectedCategory.course.find((item) => item.id === this.note.course_id)
            : selectedClass.courses.find((item) => item.id === this.note.course_id);
          this.courseSelcted = selectedCourse.name;

          const selectedExam = selectedClass.exam_type.find((item) => item.code == this.note.exam_id);
          this.taskSelcted = selectedExam.name;

          this.ListStudentNotes();
          this.isSelected = true;
          this.isError = false;
        }
      } catch (error) {
        console.error("error:", error);
      }
    },
    async ListNotesFilter(class_type_id) {
      const config = {
        params: {
          class_type_id: class_type_id || null,
        },
      };
      try {
        const res = await NoteService.ListStudentNotesFilter(config);
        this.classes = res.data.classes;
      } catch (error) {
        console.error("error: ", error);
      }
    },
    async ListStudentNotes() {
      try {
        const {classe_id, period_id, exam_id, course_id} = this.note;
        const config = {
          params: {
            class: classe_id,
            period_id,
            exam: exam_id.toLowerCase(),
            course_id,
          },
        };
        const response = await NoteService.ListStudentNotes(config);

        const data = response.data.data;
        if (data) {
          this.exam_type_id = data.exam_type_id;
          this.note.students = data.students;
          this.periodsSelcted = data.period_name;
          this.classNameSelcted = data.class_name;
          this.courseSelcted = data.course_name;
          this.published = data.status === 1;
          this.displayCategory = [1, 4].includes(data.school_category_id);
          if (this.$route.name == "editNote") {
            this.categorySelected = this.displayCategory ? ` - ${data.field_name}` : "";
            this.note.category_id = data.field_id;
          }
          this.taskSelcted = data.exam_type_name;
          this.note.students.forEach((item) => {
            item.absent = item.mark === -1;
          });
        }

        this.loading = false;
      } catch (error) {
        console.error("error: ", error);
      }
    },
    prepareFormatData(data) {
      let students = [];
      data.students.map((item) => {
        let object = {
          student_id: item.id,
          mark: item.absent ? -1 : parseFloat(item.mark),
          remark: item.remark,
        };
        students.push(object);
      });
      let formatData = {
        exam_period_id: data.period_id,
        course_id: data.course_id,
        class_id: data.classe_id,
        exam_type_id: this.exam_type_id,
        field_id: this.displayCategory ? data.category_id : null,
        status: data.status,
        students: students,
      };
      return formatData;
    },
    onSubmit(type) {
      this.isDraft = type === 0;
      this.isNotDraft = type === 1;
      this.note.status = type;
      this.v$.$validate();
      this.selectclass = this.note.classe_id;
      this.selectCourse = this.note.course_id;
      this.selectPeriode = this.note.period_id;
      this.scrollToTop();
      this.isError = true;
      if (!this.v$.$error) {
        const data = this.prepareFormatData(this.note);
        this.isSubmitted = true;
        NoteService.create(data)
          .then((response) => {
            if (this.isDraft) {
              this.is_createdDraft = true;
            }
            if (this.isNotDraft) {
              this.is_created = true;
            }
            this.$router.push({name: "addNote"});
          })
          .finally(() => {
            this.isSubmitted = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.note-input {
  max-width: 60px;
  margin: 0 auto;
  text-align: center;
  color: #333333;
  font-size: 12px;
}
.btn-cancel {
  background: transparent;
}
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.title-filter {
  font-size: 14px;
  font-weight: 700;
  color: #3d3d3d;
}
.title-filter {
  span {
    color: #377879;
  }
}
.title-filter-sub {
  font-size: 11px;
  font-weight: 500;
  color: #3d3d3d;
  font-style: italic;
  margin-left: 10px;
}

.btn-confirm-filter {
  margin-left: auto;
  margin-top: 15px;
  font-size: 14px;
  font-weight: 600;
  background-color: #377879;
  border-color: #377879;
}
.btn-confirm-filter:hover {
  color: #377879 !important;
  border-color: #377879;
}
.table__note.table > :not(caption) > * > * {
  border: none;
}
.table__note.table table td {
  border: none;
}
.table__note {
  padding: 4px;
  table {
    border-radius: unset;
    background: unset;
    padding: 23px;
    thead {
      tr {
        border-top: 3px solid #e0e7ed !important;
        border-bottom: 3px solid #e0e7ed !important;
        background: #f1fafa !important;
        th {
          color: #377879;
          font-size: 13px;
          font-weight: 700;
        }
      }
    }
    tbody {
      td {
        padding: 8px;
      }
      td.name-std {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}
.content-note {
  background: #fff;
  border-radius: 5px;
}
.title-tab-note {
  margin-bottom: 0;
  margin-top: 12px;
}
.btn-action {
  margin-top: 20px;
}
.cment-inp {
  input {
    padding-left: 20px;
    font-size: 12px;
    color: #333333;
  }
  input::placeholder {
    font-style: italic;
    color: #a098ae;
  }
}
.container-note {
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 11px;
  padding-right: 0;
}
.btn-action-note {
  .button.btn-primary {
    background: #377879;
    border: 1px solid #377879;
  }
  .button.btn-primary:hover {
    background: #fff;

    color: #377879 !important;
  }
  .btn-cancel {
    color: #377879 !important;
    border: 1px solid #377879;
  }
  .btn-cancel:hover {
    background: #377879;
    color: #fff !important;
  }
}
.reset_note {
  color: #34b9bb;
  font-size: 14px;
  font-weight: 600;
}
.supparation {
  width: 100%;
  margin: 16px 0 19px 0;
  border-top: 1px solid #e0e7ed;
}
</style>
